import { useState } from 'react';
import NcfStatusAdmin from '../components/ncf/NcfStatusAdmin.jsx';
import NcfFieldInventoryAdmin from '../components/ncf/NcfFieldInventoryAdmin.jsx';
import NcfSubmissionSettingsAdmin from '../components/ncf/NcfSubmissionSettingsAdmin.jsx';

function NcfTemplateAdmin() {
  const [activeAdminTab, setActiveAdminTab] = useState('statuses');

  return (
    <section className="content-section ncf-workspace-panel">
      <div className="section-heading"><div><h2>NCF administration</h2></div></div>
      <nav className="ncf-admin-subtabs" aria-label="NCF admin sections">
        <button type="button" className={activeAdminTab === 'statuses' ? 'active' : ''} onClick={() => setActiveAdminTab('statuses')}>Statuses</button>
        <button type="button" className={activeAdminTab === 'fields' ? 'active' : ''} onClick={() => setActiveAdminTab('fields')}>NCF Field Inventory</button>
        <button type="button" className={activeAdminTab === 'submission-settings' ? 'active' : ''} onClick={() => setActiveAdminTab('submission-settings')}>Submission Status</button>
      </nav>
      {activeAdminTab === 'statuses' && <NcfStatusAdmin />}
      {activeAdminTab === 'fields' && <NcfFieldInventoryAdmin />}
      {activeAdminTab === 'submission-settings' && <NcfSubmissionSettingsAdmin />}
    </section>
  );
}

export default NcfTemplateAdmin;
